import React from "react";

import NeighborhoodGroupList from "./NeighborhoodGroupList";
import {
  AnimatedModal,
  ModalContent,
  ModalHeader,
} from "../../modals/AnimatedModal";
import WorkspacesIcon from "@mui/icons-material/Workspaces";

export default function NeighborhoodGroupListModal({ show, closeModal }) {
  return (
    <AnimatedModal
      isOpen={show}
      onClose={closeModal}
      width="60%"
      maxWidth="1000px"
    >
      <ModalHeader
        title="Matriz de Entrega"
        icon={WorkspacesIcon}
        onClose={closeModal}
      />
      <ModalContent width={"40%"} height={"65%"} overflow={"auto"}>
        <NeighborhoodGroupList />
      </ModalContent>
    </AnimatedModal>
  );
}
